<script setup lang="ts">
import { ref } from 'vue'
import { api, messageFrom, setCsrfToken } from '../api'

const emit = defineEmits<{ loggedIn: [] }>()
const code = ref('')
const codeRequested = ref(false)
const busy = ref(false)
const error = ref('')

async function requestCode(): Promise<void> {
  if (busy.value) return
  busy.value = true
  error.value = ''
  try {
    await api<{ sent: boolean }>('/api/admin/auth/request-code', { method: 'POST', body: '{}' })
    codeRequested.value = true
    code.value = ''
  } catch (reason) { error.value = messageFrom(reason) }
  finally { busy.value = false }
}

async function submit(): Promise<void> {
  if (code.value.length !== 4 || busy.value) return
  busy.value = true
  error.value = ''
  try {
    const response = await api<{ authenticated: boolean; csrfToken: string }>('/api/admin/auth/login', {
      method: 'POST', body: JSON.stringify({ code: code.value }),
    })
    setCsrfToken(response.csrfToken)
    code.value = ''
    emit('loggedIn')
  } catch (reason) { error.value = messageFrom(reason) }
  finally { busy.value = false }
}
</script>

<template>
  <main class="login-page">
    <form class="login-card" @submit.prevent="submit">
      <p class="eyebrow">Личный архив</p>
      <h1>Техник</h1>
      <p class="login-intro">Аудиозаписи и расшифровки личных историй.</p>
      <template v-if="codeRequested">
        <label for="code">Код из Telegram</label>
        <input
          id="code"
          v-model="code"
          class="login-code"
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="4"
          pattern="[0-9]{4}"
          autofocus
          @input="code = code.replace(/\D/g, '').slice(0, 4)"
        />
      </template>
      <p v-if="error" class="field-error" role="alert">{{ error }}</p>
      <template v-if="codeRequested">
        <div class="login-actions">
          <button class="button button--primary" type="submit" :disabled="busy || code.length !== 4">
            {{ busy ? 'Входим…' : 'Войти' }}
          </button>
          <button class="button button--quiet" type="button" :disabled="busy" @click="requestCode">
            Прислать ещё раз
          </button>
        </div>
      </template>
      <button v-else class="button button--primary button--full" type="button" :disabled="busy" @click="requestCode">
        {{ busy ? 'Отправляем…' : 'Прислать код' }}
      </button>
    </form>
  </main>
</template>
